/**
 * 与 iff_dict_type.dict_type 及后端约定一致的业务字典类型标识
 */
export const DICT_TYPE = {
  /** 工具台账-工具类型 */
  TOOL_TYPE: 'tool_type',
  /** 材料台账-材料类型 */
  MATERIAL_TYPE: 'material_type',
  /** 材料台账-计量单位 */
  MATERIAL_UNIT: 'material_unit',
  /** 消防文件-文件分类 */
  FIREFILE_TYPE: 'firefile_type'
};
